// extracted by mini-css-extract-plugin
export var closeButton = "_jd-1";
export var closeX = "_jd-3";
export var container = "_jd-0";
export var image = "_jd-2";